import styled from '@emotion/styled';

export const videoElementCss = `
  body {
    background: inherit;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  video,
  #h5live-video-container {
    object-fit: contain;
    left: initial !important;
    top: initial !important;
    transform: none !important;
    margin: 0 !important;
    width: initial !important;
  }
`;

export const fullScreenVideoElementCss = `
  body {
    background: inherit;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  video,
  #h5live-video-container {
    object-fit: cover;
    left: initial !important;
    top: initial !important;
    transform: none !important;
    margin: 0 !important;
    width: 100% !important;
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  z-index: -1;
  display: flex;
  align-items: center;
  justify-content: center;

  ${videoElementCss};

  > div {
    display: none !important;
  }

  ${({ hideControls }) => hideControls
    && `
    canvas {
      display: none;
    }
  `}
`;
